/**
=========================================================
* Castelec MX - v0.0.0
=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import SignIn from "layouts/authentication/sign-in";

import Document from "examples/Icons/Document";

import OrdenesDeDispersion from "layouts/reportes/ordenes-de-dispersion";
import { TestLogin } from "layouts/test/TestLogin";
import Configuracion from "./layouts/configuracion";
import { ReportesCreditos } from "layouts/reportes/creditos";


var routespages = [
    {
        type: "collapse",
        name: "Ordenes de Dispersión",
        key: "reportes-ordenes-de-dispersion-",
        route: "/reportes/ordenesdedispersion-detalle",
        icon: <Shop size="12px" />,
        component: <OrdenesDeDispersion />,
        noCollapse: true,
        role: ['Admin']
    },
    {
        type: "collapse",
        name: "Ordenes de Dispersión",
        key: "ordenes-de-dispersion",
        route: "/reportes/ordenes-de-dispersion",
        icon: <Shop size="12px" />,
        component: <OrdenesDeDispersion />,
        noCollapse: true,
        role: ['Admin']
    },
    {
        type: "collapse",
        name: "Pruebas",
        key: "pruebas",
        route: "/test/pruebas",
        icon: <Shop size="12px" />,
        component: <TestLogin />,
        noCollapse: true,
        role: ['Admin']
    },
    {
        type: "collapse",
        name: "Mi configuración",
        key: "configuracion",
        route: "/configuracion",
        icon: <Shop size="12px" />,
        component: <Configuracion />,
        noCollapse: true,
        role: ['Autorizador', 'Admin']
    },
    {
        type: "collapse",
        name: "Creditos",
        key: "creditos-de-rfcs",
        route: "/reportes/creditos",
        icon: <Shop size="12px" />,
        component: <ReportesCreditos />,
        noCollapse: true,
        role: ['Admin']
    },
    /*
    {
        type: "collapse",
        name: "Iniciar sesión",
        key: "sign-in",
        route: "/authentication/sign-in",
        icon: <Document size="12px" />,
        component: <SignIn />,
        noCollapse: true,
      }
      */
];

export default routespages;
